import { FormattedMessage } from 'react-intl';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import { getContentToShare } from 'widget/components/share-channel/share-channel';
import { openPreviewPrompt } from 'widget/components/preview-prompt/preview-prompt';

import socialNetworkNames from 'widget/player-widget/constants/social-networks';

import SocialShare from 'widget/player-widget/components/social-share/social-share';

import styles from './share-channel.styl';

import translations from '../../translations';


@WixConnect(styles)
export default class ShareChannel extends React.Component {

  static propTypes = {
    channelData: React.PropTypes.object,
    appSettings: React.PropTypes.object,
  };

  render() {
    const { appSettings, channelData } = this.props;
    const networksClassNames = _.pick(styles, _.values(socialNetworkNames));
    const contentToShare = getContentToShare(channelData, appSettings);

    return (
      <div styleName="share-overlay"
           data-hook="shareChannelOverlay">
        <div styleName="title">
          <FormattedMessage {...translations.shareThisChannel} />
        </div>
        {/*TODO: onAfterClicked={sendBi, sendReport and other stuff}*/}
        <SocialShare appSettings={appSettings}
                     networks={_.values(socialNetworkNames)}
                     content={contentToShare}
                     styleName="social-icons"
                     buttonClassName={styles['share-icon']}
                     popoutOuterClassName={styles['popout-outer']}
                     popoutInnerClassName={styles['popout-inner']}
                     openPreviewPrompt={openPreviewPrompt}
                     linkClassName={styles['share-link']}
                     networksClassNames={networksClassNames} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/share-channel/share-channel.js